module.exports = __webpack_public_path__ + "img/fumble.93b25593.jpg";